import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  defineShipmentsTitle: {
    defaultMessage: '{index}Define Shipments',
    id: 'EWQuaK',
    description: 'Title of the define shipments step',
  },
  configuredBoxesCount: {
    defaultMessage: '{count, plural, one {# Box configured} other {# Boxes configured}}',
    id: 'WVRe2H',
    description: 'Count of boxes added to the define shipments table.',
  },
  addBoxConfiguration: {
    defaultMessage: 'Add Box Configuration',
    id: 'LGCnD+',
    description: 'Add box Configuration button text',
  },
  configuredPalletsCount: {
    defaultMessage: '{count, plural, one {# Pallet configured} other {# Pallets configured}}',
    id: '/7MIOi',
    description: 'Count of pallets added to the define shipments table.',
  },
  addPalletConfiguration: {
    defaultMessage: 'Add Pallet Configuration',
    id: 'bC/kpA',
    description: 'Add pallet Configuration button text',
  },
  quantityRemainingErrorHeader: {
    defaultMessage: 'Some products do not have a valid quantity remaining.',
    description: 'Header of banner error to inform user products do not have the correct quantities set',
    id: 'K8hOIH',
  },
  quantityRemainingErrorBody: {
    defaultMessage:
      'To save your shipment definition, please ensure that all products have a zero (0) quantity remaining. If this is incorrect, please reset your quantities in the previous step.',
    description: 'Body of banner error to inform user products do not have the correct quantities set',
    id: 'Ez8xu9',
  },
  deletePalletsConfirmModalHeader: {
    defaultMessage: 'Confirm Delete Pallets?',
    id: '8kHdgV',
    description: 'Header text of remove pallet confirm dialogue modal',
  },
  deletePalletsConfirmModalBody: {
    defaultMessage:
      'Are you sure you want to delete all pallets? All products and quantities associated with these pallets will be removed as well.',
    id: 'SOfpRw',
    description: 'Body text of remove all pallets confirm dialogue modal',
  },
  deleteBoxesConfirmModalHeader: {
    defaultMessage: 'Confirm Delete Boxes?',
    id: 'NgDt08',
    description: 'Header text of remove boxes confirm dialogue modal',
  },
  deleteBoxesConfirmModalBody: {
    defaultMessage:
      'Are you sure you want to delete all boxes? All products and quantities associated with these boxes will be removed as well.',
    id: 'cgSWHG',
    description: 'Body text of remove all boxes confirm dialogue modal',
  },
});
